import React from 'react';

const extractFormFields = (components) => {
    const fields = [];
    if (!components) return fields;
    const dataTypes = ['textfield', 'textarea', 'number', 'select', 'radio', 'checklist', 'datetime', 'date', 'taglist'];
    components.forEach(component => {
        if (dataTypes.includes(component.type)) {
            fields.push({ key: component.key, label: component.label || component.dateLabel || component.key });
        } else if (component.type === 'dynamiclist' && component.components) {
            fields.push({ key: component.key, label: component.label || component.key, isDynamicList: true, subComponents: component.components });
        } else if (component.components) {
            fields.push(...extractFormFields(component.components));
        }
    });
    return fields;
};

const FormDataSummary = ({ schema, formData }) => {
    if (!schema?.components || !formData) return <p style={styles.empty}>No form data available.</p>;

    const fields = extractFormFields(schema.components);
    const entries = fields.flatMap(field => {
        const value = formData[field.key];
        if (value === undefined || value === null || value === '') return [];

        if (field.isDynamicList && Array.isArray(value)) {
            return value.map((item, i) => ({
                key: `${field.key}-${i}`,
                label: `${field.label} #${i + 1}`,
                display: Object.entries(item).map(([k, v]) => `${k}: ${v}`).join(' | '),
            }));
        }

        const display = Array.isArray(value) ? value.join('\n') : String(value);
        return [{ key: field.key, label: field.label, display }];
    });

    if (entries.length === 0) return <p style={styles.empty}>No form data submitted.</p>;

    return (
        <div style={styles.grid}>
            {entries.map(({ key, label, display }) => (
                <React.Fragment key={key}>
                    <span style={styles.label}>{label}</span>
                    <span style={styles.value}>{display}</span>
                </React.Fragment>
            ))}
        </div>
    );
};

const CaseDetailsModal = ({ isOpen, onClose, caseItem }) => {
    if (!isOpen || !caseItem) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">Application Details</h2>
                    <button className="modal-close" onClick={onClose}>X</button>
                </div>
                <div className="modal-body">
                    <FormDataSummary
                        schema={caseItem.service?.formSchema}
                        formData={caseItem.formData}
                    />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    grid: {
        display: 'grid',
        gridTemplateColumns: '180px 1fr',
        gap: '12px 20px',
        fontSize: '0.95rem',
        padding: '8px 4px',
    },
    label: {
        fontWeight: '600',
        color: '#495057',
        textAlign: 'right',
        paddingTop: '1px',
    },
    value: {
        color: '#212529',
        whiteSpace: 'pre-line',
        borderBottom: '1px solid #f0f0f0',
        paddingBottom: '8px',
    },
    empty: {
        color: '#888',
        fontStyle: 'italic',
    },
};

export default CaseDetailsModal;
